exports.baseURL = 'https://admin.talentinco.com/';
// exports.baseURL = 'http://192.168.1.39:5038/';
exports.key = 'LiRhuZZejJFrDZEHCtyLO0q2bDuIIhJL';
exports.projectName = 'Talent';
